<script>
import addressMixin from "@/mixins/addressMixin";

export default {
  mixins: [addressMixin],
  props: {
    address: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    edit() {
      this.$emit("edit", this.address);
    },
    remove() {
      this.$emit("delete", this.address);
    }
  }
};
</script>

<template>
  <div
    class="address"
    :class="{selected: selected}"
    @click="$emit('selected', address)"
    v-if="address"
  >
    <div class="radio-address"></div>
    <div class="title-address">{{address.name}}</div>
    <div class="mt-5">
      <i>{{address.zip_code}}</i>
    </div>
    <div class="text-center">{{address | fullAddress}}</div>

    <div class="buttons-address">
      <!-- <div @click.stop="remove" class="m-5">
        <img src="/static/icon-remove.svg" height="15px">
      </div>-->

      <div class="btn btn-small btn-rounded bg-purple-outline" @click.stop="edit">
        <img src="/static/icon-edit.svg" height="12px" class="mr-5" /> editar
      </div>
    </div>
  </div>
</template>

<style scoped>
.address {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 180px;
  border: 2px solid #eee;
  border-radius: 4px;
  margin: 10px;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
}

.address.selected {
  border-color: var(--purple);
}

.address.selected .radio-address {
  background: var(--purple);
}

.radio-address {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  border: 2px solid var(--purple);
  margin-bottom: 10px;
}

.title-address {
  font-weight: 600;
  color: var(--purple);
  text-transform: uppercase;
  text-align: center;
}

.buttons-address {
  display: flex;
  margin-top: 10px;
}

.buttons-address div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.btn-small {
  padding: 5px 8px;
}

@media (max-width: 480px) {
  .address {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/Address.vue